<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <v-card outlined class="benefit-summary-card h-100">
    <v-card-title class="pb-2 d-flex align-center">
      <v-avatar color="primary" size="36" class="mr-3">
        <span class="white--text text-body-1 font-weight-bold">
          {{ initials }}
        </span>
      </v-avatar>
      <div class="flex-grow-1 overflow-hidden">
        <div class="text-subtitle-1 font-weight-semibold text-truncate">
          {{ item.user_first_name || 'Пользователь' }}
        </div>
        <div v-if="item.user_id" class="text-caption text--secondary">
          ID {{ item.user_id }}
        </div>
      </div>
    </v-card-title>

    <v-divider />

    <v-card-text class="pt-3">
      <div
        v-for="row in rows"
        :key="row.label"
        class="summary-row d-flex py-2"
      >
        <span class="summary-label text--secondary text-body-2 flex-shrink-0 mr-2">
          {{ row.label }}
        </span>
        <span class="summary-value text-body-2 font-weight-medium flex-grow-1">
          <component :is="row.component || 'span'" v-if="row.component" v-bind="row.props" />
          <template v-else-if="row.isSource">
            <v-chip x-small outlined label>{{ row.value || '—' }}</v-chip>
          </template>
          <template v-else>{{ row.value || '—' }}</template>
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDateTime } from '../utils'
import BenefitDocumentPreview from './BenefitDocumentPreview.vue'
import BenefitStatusChip from './BenefitStatusChip.vue'

export default {
  name: 'BenefitRequestSummaryCard',
  components: { BenefitStatusChip, BenefitDocumentPreview },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    initials() {
      const name = this.item.user_first_name || ''
      return name.trim().charAt(0).toUpperCase() || '?'
    },
    rows() {
      const i = this.item || {}
      return [
        { label: 'Дата заявки', value: formatDateTime(i.created_at) },
        { label: 'Категория', value: i.requested_category_name || '—' },
        { label: 'Источник', isSource: true, value: i.source },
        { label: 'Комментарий', value: i.comment || '—' },
        {
          label: 'Документ',
          component: i.file_url ? 'benefit-document-preview' : null,
          props: i.file_url ? { url: i.file_url } : null,
          value: i.file_url ? null : '—',
        },
      ]
    },
  },
}
</script>

<style scoped>
.summary-label {
  min-width: 120px;
}
.summary-row + .summary-row {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
